module.exports = __webpack_public_path__ + "img/dovs_eosvaultfort.c30ef15.png";